import { useField, useFormikContext } from 'formik';
import { type FC } from 'react';

import { MultiSelect } from '../../InputFields';

import type { FormikFormField, MenuItem } from '@/types/formTypes';

interface FormikMultiSelectProps {
  name: string;
  label: FormikFormField['label'];
  menuItems?: MenuItem[];
  disabled?: boolean | string;
}

export const FormikMultiSelect: FC<FormikMultiSelectProps> = ({
  name,
  label,
  menuItems = [],
  disabled = false,
}) => {
  const [field, meta, helpers] = useField(name);
  const { values } = useFormikContext<Record<string, (string | number)[] | undefined>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  const handleChange = (newValue: (string | number)[]): void => {
    const newValues = Array.isArray(newValue) && !newValue.includes('') ? newValue : [];
    helpers.setValue(newValues);
  };

  return (
    <MultiSelect
      id={field.name}
      name={field.name}
      value={Array.isArray(values[field.name]) ? values[field.name] : []}
      onChange={handleChange}
      onBlur={field.onBlur}
      {...(label && { label: label as string })}
      menuItems={menuItems}
      disabled={isDisabled}
      {...(meta.touched && { helperText: meta.error })}
    />
  );
};
